import React, { useState, useEffect, Component } from "react";
import {
  Col,
  Row,
  Button,
  Form,
  Input,
  Label,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import { Redirect, Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import "./formsTable.css";
import "./baseForms.css";
import "./myReactSelect.css";
import moment from "moment";
import swal from "@sweetalert/with-react";
import { CheckClosingYearD } from "../../ShortFunction/CheckClosingYearD";
import Responseloader from "../../ShortCutComponents/ResponseLoader";
import DatePicker from "react-datepicker";

let username = localStorage.getItem("username");
let companyId = localStorage.getItem("companyId");
var token = localStorage.getItem("token");
var thisContex;
function dueFormatorsComma(cell) {
  let cett = "";
  if (cell) {
    cell = cell.toString().replaceAll(",", "");
    if (typeof cell === "string") {
      cell = Number(cell);
    }

    cett = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    cett = 0;
  }
  return cett;
}
// export default function PurchaseRefund(props) {
class PurchaseRefund extends Component {
  constructor(props) {
    super(props);
    thisContex = this;

    let params = props.location?.state;
    let tempLogedIn = false;
    console.log(params);

    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      logInStatus: tempLogedIn,
      banks: "",
      amount: params?.amount.toFixed(2),
      conv_rate: params?.conv_rate,
      date: new Date(),
      supp_id: params?.supp_id,
      inv_id: params?.pur_ret_id,
      supp_name: params?.supp_name,
      inv_date: moment(params?.pur_inv_date).format("DD-MMM-YYYY"),
      companyCurSymbol: params?.companyCurSymbol,
      currencyId: params?.currencyId,
      username: username,
      redirect_back_overview: false,
      loadingResponce: false,
      companyId: companyId,
      totalAmount: Number(params?.amount.toFixed(2)),
      remAmount: 0,
      inv_doc_no: params?.inv_doc_no,
    };
  }

  handleChangeLovsSelect = (bankId) => {
    console.log(bankId);
    this.setState({
      bankId,
      customerName: bankId?.label,
      customerEmail: bankId?.email,
    });
  };

  checkDateOfYear = async (e) => {
    var refundDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      refundDate = this.state.date;
    } else {
      byDefault = "";
      refundDate = e;
    }
    const tableName = "supp_refund_mt";
    const invoiceType = 14;
    const invBookId = 14;
    const dateColumn = "doc_date";
    const documentNo = "doc_no";
    console.log("refund date for checkclosefun", refundDate);
    var date = moment(refundDate).format("YYYY-MM-DD");
    console.log(date);
    let closeDate = await CheckClosingYearD(
      date,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault
    );
    var docNo = closeDate[1];
    console.log("closeDatecloseDatecloseDate", closeDate);

    if (closeDate[0] === true) {
      this.setState({
        date: "",
        doc_no: "",
      });
    } else if (closeDate[0] === false) {
      this.setState({
        date: refundDate,
        doc_no: docNo,
      });
    } else {
      this.setState({
        date: "",
        doc_no: "",
      });
    }
    // return { date: dateS, doc_no: doc_noS };
  };

  onChangeDatePicker = async (e) => {
    this.checkDateOfYear(e);
  };
  handleChangeItem = async (e) => {
    let myAmount = Number(e.target.value?.replaceAll(",", ""));
    if (myAmount < 0) {
      this.setState({
        amount: "",
        paymentError: "Negative Entry is not allowed",
      });
    } else {
      this.setState({
        amount: e.target.value,
        paymentError: "",
      });
    }
  };
  onBlurCall = (e) => {
    let propAmount = Number(this.props.location?.state?.amount);
    let myAmount = Number(this.state.amount?.replaceAll(",", ""));
    if (myAmount > propAmount) {
      this.setState({
        amount: "",
        paymentError: "You cannot enter amount greater than Due balance",
      });
    } else {
      this.setState({
        paymentError: "",
      });
    }
  };
  componentDidMount() {
    this.getBranchLov()
    let banks = [];
    const { username, companyId } = this.state;
    axios
      .post(
        `${baseurl}/lovs/getBankCash`,
        { username: username, companyId: companyId },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(async function (response) {
        banks = response.data.data;
        var refundDate;

        refundDate = thisContex.state.date;

        const tableName = "supp_refund_mt";
        const invoiceType = 14;
        const invBookId = 14;
        const dateColumn = "doc_date";
        const documentNo = "doc_no";
        console.log("refund date for checkclosefun", refundDate);
        var date = moment(refundDate).format("YYYY-MM-DD");
        console.log(date);
        let closeDate = await CheckClosingYearD(
          date,
          tableName,
          invoiceType,
          invBookId,
          dateColumn,
          documentNo,
          "didMount"
        );
        var docNo = closeDate[1];
        console.log("closeDatecloseDatecloseDate", closeDate);
        let dateS = "";
        let doc_noS = "";
        if (closeDate[0] === true) {
          dateS = "";
          doc_noS = "";
        } else if (closeDate[0] === false) {
          dateS = refundDate;
          doc_noS = docNo;
        } else {
          dateS = "";
          doc_noS = "";
        }

        thisContex.setState({
          banks: banks,
          date: dateS,
          doc_no: doc_noS,
        });
      })

      .catch(function (error) {
        console.log(error);
      });
  }
  
    handleToChangeOpen = (branch) => {
     
       this.setState({
            branch, 
          });
     
    };
    
      getBranchLov = () => {
        axios
          .post(
            `${baseurl}/lovs/getDynamicBranchLov`,
    
            {
              companyId: companyId,
              username: username, 
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            let responseData = response.data.data;
    
            thisContex.setState({
              branchLov: responseData,
            });
          })
          .catch(function (error) {
            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
            console.log(error);
          });
      };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      loadingResponce: true,
    });
    const {
      amount,
      date,
      supp_id,
      inv_id,
      bankId,
      username,
      companyId,
      currencyId,
      supp_name,
branch,
      conv_rate,
    } = thisContex.state;
    let parseAmount = amount;
    parseAmount = parseFloat(
      parseAmount.toString().replaceAll(",", "")
    ).toFixed(2);
    if (1==2) {
    //update
    } else {
      axios
        .post(
          `${baseurl}/masterData/addPurRefund`,
          {
            amount: parseAmount,
            doc_date: moment(date).format("YYYY-MM-DD"),
            supp_id: supp_id,
            inv_id: inv_id,
            bankId: bankId.acct_id,
            branch: branch.id,
            username: username,
            companyId: companyId,
            currency_Id: currencyId,
            customerName: supp_name,
            conv_Rate: conv_rate,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          thisContex.setState({
            loadingResponce: false,
          });
          swal({
            title: "Transaction is Successfull!",
            text: "Purchase return refund payed to supplier",
            icon: "success",
          }).then((value) => {
            // if (!journalId) {
            //   thisContex.toggle();
            // }
            thisContex.setState({
              redirect_back_overview: true,
            });
            // thisContex.setState({
            //   isActive: !thisContex.state.isActive,
            //   disabled: !thisContex.state.disabled,
            //   masterId: thisContex.props.location.state.id,
            // });
            // thisContex.props.location.state.id = null;
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  render() {
    const {
      showDetails,
      banks,
      bankId,
      supp_name,
      amount,
      date,
      companyCurSymbol,
      inv_id,
      supp_id,
      redirect_back_overview,
      doc_no,
      inv_doc_no,
      companyId,
      username,
      currencyId,
      totalAmount,
      remAmount,
      inv_date,
      loadingResponce,
      branch,
      branchLov
    } = this.state;
    if (loadingResponce === true) {
      return <Responseloader />;
    } else {
      return (
        <React.Fragment>
          <div className="animated fadeIn">
            {redirect_back_overview ? (
              <Redirect
                push
                to={{
                  pathname: "/OverviewMoneyOut",
                }}
              />
            ) : (
              <>
                <Row className="Creative-Invoice-header-styling ">
                  <Col xs="8" className="card-header-Creative-Invoice">
                    <strong>
                      <h4>Supplier Refund </h4>
                    </strong>
                  </Col>
                  <Col xs="4" className="card-header-Creative-Invoice">
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Link
                        to="/OverviewMoneyOut"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "normal",
                          margin: "10px",
                        }}
                      >
                        <u className="Back-to-Overview">
                          Back to Money Out Overview
                        </u>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-left mx-1 icon-color"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                          />
                        </svg>
                      </Link>
                    </div>
                  </Col>
                </Row>
                <Row className="rowStyling ">
                  <div className="row p-4 ">
                    <>
                      <div
                        className="col-md-12 "
                        style={{
                          border: "1px dashed black ",
                          borderRadius: "10px 10px 0px 0px",
                          backgroundColor: "#eceeff",
                          marginBottom: "3vh",
                          marginTop: "3vh",
                        }}
                      >
                        <div className="row p-2">
                          <div className="col-md-4 ">
                            <span>Purchase Credit Note: {supp_name} </span>
                          </div>
                          <div className="col-md-3">
                            Pur. Credit Note Date: {inv_date}
                          </div>

                          <div className="col-md-5 d-flex justify-content-end">
                            <span>
                              {" "}
                              Refund: {companyCurSymbol}{" "}
                              {dueFormatorsComma(amount)} | Remaining:
                              {"  "}
                              {/* {companyCurSymbol} {totalAmount}
                          ---
                          {amount} */}
                              {totalAmount -
                                Number(
                                  amount?.toString().replaceAll(",", "")
                                ) ===
                              0
                                ? "0"
                                : dueFormatorsComma(
                                    totalAmount -
                                      Number(
                                        amount?.toString().replaceAll(",", "")
                                      )
                                  )}{" "}
                              | Total: {totalAmount}
                            </span>
                          </div>

                          <div className="col-md-3 mt-2 justify-content-end">
                            <span> Number : </span>
                            <span>{inv_doc_no} </span>
                          </div>
                          {/* <div className="col-md-6 d-flex flex-row-reverse mt-2">
                  <Link
                    onClick={() => {
                      setPurchaseRefundObj({ showDetails: !showDetails });
                    }}
                  >
                    Show Details
                  </Link>
                </div> */}
                        </div>
                      </div>
                      {showDetails === true && (
                        <>
                          <div className="row h1"> show details </div>
                        </>
                      )}
                      <div className="col-md-12">
                        <h4>Record Refund From Supplier</h4>
                        <Label>
                          You are receiving a refund from {supp_name} based on
                          discount still remaining on credit note {inv_id}.
                          Simply enter the refund you are receiving your
                          supplier below.
                        </Label>
                      </div>
                    </>
                  </div>
                  <div className="col-md-12">
                    <Form
                      name="addNewForm"
                      autocomplete="off"
                      onSubmit={this.handleSubmit}
                      onKeyPress={(event) => {
                        if (event.which === 13 /* Enter */) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <div className="row">
                        <div
                          className="col-md-4" 
                        >
                          <Label style={{ fontWeight: "bold" }}>Branch :</Label>
                          <Select
                            isClearable
                            value={branch || ""}
                            options={branchLov}
                            onChange={this.handleToChangeOpen}
                            required
                            // isDisabled={disabledState}
                            name="branch"
                            placeholder={"-- Select --"}
                          />
                        </div>
                        <div className="col-md-4">
                          <Label
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            Refund Amount:{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <InputGroup className="">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="input-tag-text">
                                {companyCurSymbol}
                              </InputGroupText>
                            </InputGroupAddon>

                            <NumberFormat
                              name="rate"
                              className="form-control"
                              style={{ textAlign: "right" }}
                              thousandSeparator={true}
                              required
                              placeholder="0.00"
                              decimalScale={2}
                              value={amount || ""}
                              // disabled={this.state.disabled ? true : false}
                              onChange={(e) => {
                                this.handleChangeItem(e);
                              }}
                              onBlur={(e) => {
                                this.onBlurCall(e);
                                // console.log('Triggered because this input lost focus');
                              }}
                            />
                          </InputGroup>
                        </div>
                        <div className="col-md-4">
                          <Label style={{ fontWeight: "bold" }}>
                            Refund Date?
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          {/* <Input
                        type="date"
                        // defaultValue="12:35"
                        // autoFocus
                        className="form-control"
                        id="invoice_date"
                        name="invoice_date"
                        placeholder="invoice_date"
                        required
                        value={date}
                        onChange={(e) => {
                          handleChangeLovs(e);
                        }}
                      /> */}
                          <DatePicker
                            wrapperClassName="datePicker"
                            id="date"
                            name="date"
                            required
                            selected={date}
                            className="form-control"
                            dateFormat="d MMMM, yyyy"
                            onChange={(date) => this.onChangeDatePicker(date)}
                          />
                        </div>
                        <div className="col-md-4">
                          <Label
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            Refund Doc#
                          </Label>
                          <InputGroup className="">
                            <NumberFormat
                              name="doc_no"
                              className="form-control"
                              style={{ textAlign: "right" }}
                              // thousandSeparator={true}
                              // required
                              placeholder="0"
                              value={doc_no || ""}
                              disabled
                              // onChange={(e) => {
                              //   this.handleChangeItem(e);
                              // }}
                            />
                          </InputGroup>
                        </div>
                        <div
                          translate="no"
                          className="col-md-6 mt-3"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Which bank was the refund paid into?{" "}
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <Select
                            value={bankId}
                            onChange={this.handleChangeLovsSelect}
                            autoFocus
                            required
                            options={banks}
                            name="bankId"
                            placeholder={
                              localStorage.getItem("comp_lang") == "ur"
                                ? "--منتخب کریں--"
                                : localStorage.getItem("comp_lang") == "ar"
                                ? "--يختار--"
                                : "--select--"
                            }
                            // disabled={this.state.disabled ? "disabled" : ""}
                          />
                        </div>
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid rgb(221, 221, 221)",
                          width: "90%",
                          position: "relative",
                        }}
                      />
                      <div className="col-md-12 d-flex flex-row-reverse mb-4">
                        <Button
                          // onClick={this.handleSubmit}
                          type="submit"
                          className="mr-1 invoiceSubmitButton "
                          id="submitId"
                        >
                          Submit
                        </Button>
                        <span className="mr-4 mt-2">
                          <Link to="/OverviewMoneyOut">
                            <a href id="cancel">
                              Cancel
                            </a>
                          </Link>
                        </span>
                      </div>
                    </Form>
                  </div>
                </Row>
              </>
            )}
          </div>
        </React.Fragment>
      );
    }
  }
}

export default PurchaseRefund;
